export const INVALID_MILEAGE_MESSAGE = "Please enter a valid mileage";
export const INVALID_POSTCODE_MESSAGE = "Invalid postcode";
export const INVALID_MOBILE_NUMBER = "Please enter a valid UK mobile number";
export const INVALID_CONTACT_NUMBER = "Please enter a valid contact number";
// Validation messages for Sales Contact Us Page
export const TITLE_REQUIRED = "Please select your title";
export const FIRSTNAME_REQUIRED = "Please provide your first name";
export const LASTNAME_REQUIRED = "Please provide your last name";
export const EMAIL_REQUIRED = "Please provide your email address";
export const EMAIL_VALID = "Please enter a valid email address";
export const POSTCODE_REQUIRED = "Please provide your postcode";
export const POSTCODE_VALID = "Please enter a valid postcode";
export const PHONE_REQUIRED = "Please enter your phone number";
export const PHONE_VALID = "Please enter a valid phone number";
export const MESSAGE_REQUIRED = "Please tell us why you are contacting us today";

// validation messages for Customer Care Page
export const VEHICLE_REGISTRATION_REQUIRED = "Please enter your vehicle registration";
export const INVALID_REGISTRATION_MESSAGE = "Please enter a valid UK vehicle registration";
export const QUERY_TYPE_REQUIRED = "Please select your query";
export const SUBJECT_REQUIRED = "Please enter a subject for why you are contacting us today";

export const MILEAGE_LENGTH_LIMIT_MESSAGE = "Please enter a number below 999999";
